import * as Sentry from '@sentry/react';

const packageJson = require('../../package.json');

const initSentry = ({ brand }) => {
  Sentry.init({
    dsn: 'https://b26ef28bed8fc05785940f1ed9dc0592@o4509545938223104.ingest.us.sentry.io/4510717920673792',
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
      Sentry.consoleLoggingIntegration({ levels: ['warn', 'error', 'info'] })
    ],
    enableLogs: true,
    tracesSampleRate: 1.0,
    sendDefaultPii: true,
    normalizeDepth: 10,
    beforeSendSpan(span) {
      span.data = {
        ...span.data,
        brand
      };
      return span;
    },
    beforeSendLog: (log) => {
      const currentSpan = Sentry.getActiveSpan();
      if (currentSpan) {
        log.attributes = {
          ...log.attributes,
          ...currentSpan,
          brand
        };
      }

      return log;
    },
    environment: process.env.REACT_APP_ENV,
    // Session Replay
    replaysSessionSampleRate: 1.0,
    replaysOnErrorSampleRate: 1.0,
    release: `${brand}@${packageJson.version}`
  });
};

export { initSentry };
